import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Themenfeld } from '../../../model/themenfeld';
import { ScreenSizeService, ViewMode } from '../../../services/screen-size';

@Component({
  selector: 'now-wbsuche-lib-themenfelder-selection',
  imports: [NgClass],
  templateUrl: './themenfelder-selection.component.html'
})
export class ThemenfelderSelectionComponent {
  private readonly screenSizeService = inject(ScreenSizeService);

  @Input({ required: true }) title = '';
  @Input({ required: true }) weiterbildungen: Themenfeld[] = [];
  @Input({ required: true }) weiterbildungenLoading: boolean = false;
  @Output() selectionEmitter = new EventEmitter<Themenfeld | null>();
  @Output() zurueckEvent = new EventEmitter();
  @Input() hideZurueckButton = false;

  isMobile = toSignal(this.screenSizeService.rangeTo$(ViewMode.PHONE));

  selectedThemenfeld: Themenfeld | null = null;

  selectThemenFeld(themenfeld: Themenfeld) {
    this.selectedThemenfeld = themenfeld;
  }

  emitSelection() {
    this.selectionEmitter.emit(this.selectedThemenfeld);
  }

  emitZurueckEvent() {
    this.zurueckEvent.emit();
  }
}
